import React from "react";
import { css } from "emotion";

/**
 * Helpers UI partagés par les onglets B2B (Pipeline, SAV, Impayés,
 * Rapprochement, Dashboard) pour garder une présentation homogène et conforme
 * aux standards : chiffres tabulaires, alignement des montants, en-têtes de
 * tableau collants, états vides soignés.
 */

// Chiffres à chasse fixe : les montants s'alignent verticalement colonne par colonne.
export const moneyCellStyle = {
  textAlign: "right",
  whiteSpace: "nowrap",
  fontVariantNumeric: "tabular-nums",
};

export const tabularNums = { fontVariantNumeric: "tabular-nums" };

// En-tête de tableau qui reste visible au scroll (à poser en className sur <Table>).
export const stickyTable = css({
  "& thead th": {
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#fff",
    boxShadow: "inset 0 -1px 0 #dee2e6",
  },
});

/**
 * État vide / première utilisation : bloc centré, discret, avec un éventuel
 * picto, un titre, une aide et une action.
 */
export const EmptyState = ({ icon, title, hint, action, className = "" }) => (
  <div
    className={className}
    style={{
      textAlign: "center",
      padding: "40px 16px",
      color: "#6c757d",
      background: "#fafafa",
      border: "1px dashed #dee2e6",
      borderRadius: 8,
    }}
  >
    {icon && <div style={{ fontSize: 32, marginBottom: 8, opacity: 0.6 }}>{icon}</div>}
    {title && <div style={{ fontWeight: 600, color: "#495057", marginBottom: 4 }}>{title}</div>}
    {hint && <div style={{ fontSize: 13 }}>{hint}</div>}
    {action && <div style={{ marginTop: 12 }}>{action}</div>}
  </div>
);

// Placeholder discret pour une colonne kanban vide.
export const ColumnEmpty = ({ children = "Aucune carte" }) => (
  <div
    style={{
      textAlign: "center",
      color: "#adb5bd",
      fontSize: 12,
      padding: "24px 8px",
      fontStyle: "italic",
    }}
  >
    {children}
  </div>
);
